const CaseDetailsInfo = (state = {
    caseId: 0,
    fromType:'',
    visible: false
}, action) => {
    switch (action.type) {
        case "showCaseInfo":
            return state = {
                caseId: action.caseId,
                fromType: action.fromType,
                visible: true
            };
        case "hideCaseInfo":
            return state = {
                caseId: action.caseId,
                fromType: action.fromType,
                visible: false
            };
        default:
            return state;

    }
};
export default CaseDetailsInfo




// WEBPACK FOOTER //
// ./src/reducers/CaseDetailsInfo.js